let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("feYM5")).then(() => parcelRequire('7yl2G'));